
import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import OfficeCaptureFields from "./OfficeCaptureFields";

const CustomInput = React.forwardRef(({ value, onClick, onChange }, ref) => (
  <input
    type="text"
    className="form-control"
    onClick={onClick}
    onChange={onChange}
    ref={ref}
    value={value}
    readOnly
  />
));

const CustomerDetails = ({
    customerDetails,
    handleTelChange,
    isPhoneNumberValid,
    handleNextButtonClick,
    dropOffType,
    setCustomerDetails,
    setDropOffType, 
    isFormValid,
    customerId,
    showIncidentHistory = true,
    demoAppInstalled,
    onDemoAppInstalledChange,
    onPhotoSelected,
    onLocationCaptured,
    resetKey,
}) => {
    const [customerIncidents, setCustomerIncidents] = useState([]);
    const [loading, setLoading] = useState(false);

    // Fetch customer incidents when customerId changes
    useEffect(() => {
        if (customerId) {
            fetchCustomerIncidents();
        }
    }, [customerId]);

    const fetchCustomerIncidents = async () => {
        setLoading(true);
        try {
            const response = await fetch(`api/ProspCustomers/GetCustomerIncidents?customerId=${customerId}`);
            if (response.ok) {
                const data = await response.json();
                setCustomerIncidents(data);
            }
        } catch (error) {
        } finally {
            setLoading(false);
        }
    };
    return (
        <>
            <div className="customer-details-container p-4 mb-4 bg-light border rounded shadow-lg">
            <h2>Customer Details</h2>
            <form>
                <div className="customer-details-fields">
                    <div className="mb-3">
                        <label htmlFor="companyName" className="form-label">
                            Company Name:
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="companyName"
                            value={customerDetails.companyName}
                            onChange={(e) =>
                                setCustomerDetails({
                                    ...customerDetails,
                                    companyName: e.target.value,
                                })
                            }
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="contactPerson" className="form-label">
                            Contact Person:
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="contactPerson"
                            value={customerDetails.contactPerson}
                            onChange={(e) =>
                                setCustomerDetails({
                                    ...customerDetails,
                                    contactPerson: e.target.value,
                                })
                            }
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="tel" className="form-label">
                            Telephone Number:
                        </label>
                        <input
                            type="tel"
                            className={`form-control ${isPhoneNumberValid ? '' : 'is-invalid'}`}
                            id="tel"
                            value={customerDetails.tel}
                            onChange={handleTelChange}
                        />
                        {!isPhoneNumberValid && (
                            <div className="invalid-feedback">
                                Please enter a valid phone number.
                            </div>
                        )}
                    </div>
                    <div className="mb-3">
                        <label htmlFor="dropOffType" className="form-label text-black">
                            Drop-Off Type:
                        </label>
                        <select
                            className="form-select"
                            id="dropOffType"
                            style={{ height: '38px' }}
                            value={dropOffType}
                            onChange={(e) => setDropOffType(e.target.value)}
                        >
                            <option value="" disabled>Select Drop-Off Type</option>
                            <option value="sample">Sample Drop-Off</option>
                            <option value="return">Sales or Return</option>
                        </select>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="incidentType" className="form-label">
                            Incident Type:
                        </label>
                        <select
                            className="form-select"
                            id="incidentType"
                            value={customerDetails.incidentType || ''}
                            onChange={(e) => setCustomerDetails({
                                ...customerDetails,
                                incidentType: e.target.value
                            })}
                        >
                            <option value="" disabled>Select Incident Type</option>
                            <option value="Visit">Visit</option>
                            <option value="Telephone Call">Telephone Call</option>
                            <option value="Whatsapp">Whatsapp</option>
                            <option value="Email">Email</option>
                        </select>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="date" className="form-label">
                            Date:
                        </label>
                        <DatePicker
                            id="date"
                            selected={customerDetails.date ? new Date(customerDetails.date) : new Date()}
                            onChange={date => setCustomerDetails({
                                ...customerDetails,
                                date: date ? date.toISOString() : null
                            })}
                            dateFormat="yyyy-MM-dd"
                            placeholderText="Select a date"
                            customInput={<CustomInput />}
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="refNo" className="form-label">
                            Ref.No:
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="refNo"
                            value={customerDetails.refNo}
                            onChange={(e) =>
                                setCustomerDetails({
                                    ...customerDetails,
                                    refNo: e.target.value,
                                })
                            }
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="incident" className="form-label">
                            Incident:
                        </label>
                        <textarea
                            className="form-control"
                            id="incident"
                            rows="2"
                            value={customerDetails.incident || ''}
                            onChange={e => setCustomerDetails({
                                ...customerDetails,
                                incident: e.target.value
                            })}
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="address" className="form-label">
                            Address:
                        </label>
                        <textarea
                            className="form-control"
                            id="address"
                            rows="1"
                            value={customerDetails.address}
                            onChange={(e) =>
                                setCustomerDetails({
                                    ...customerDetails,
                                    address: e.target.value,
                                })
                            }
                        />
                    </div>
                    <OfficeCaptureFields
                        key={resetKey}
                        demoAppInstalled={demoAppInstalled}
                        onDemoAppInstalledChange={onDemoAppInstalledChange}
                        onPhotoSelected={onPhotoSelected}
                        onLocationCaptured={onLocationCaptured}
                    />
                </div>
                <div className="text-center mt-4">
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => {
                            // Validate drop-off type and incident type
                            if (!dropOffType) {
                                alert('Please select a Drop-Off Type before proceeding.');
                                return;
                            }
                            if (!customerDetails.incidentType) {
                                alert('Please select an Incident Type before proceeding.');
                                return;
                            }
                            const stockGroupTable = document.getElementById('descriptionAccordion');
                            if (stockGroupTable) {
                                stockGroupTable.scrollIntoView({ behavior: 'smooth' });
                            }
                            handleNextButtonClick(); // Call the original click handler
                        }}
                        disabled={!isFormValid()}
                    >
                        Next
                    </button>
                </div>
            </form>
        </div>
        </>
    );
};

export default CustomerDetails;